
import API from './apiConfig';

const createOrder = (_data)=>{
    return API.post('/order', _data);
}

const paymentVerify = (_data)=>{
    return API.post('/verify', _data);
}


const apiService = {
    createOrder,
    paymentVerify
};

export default apiService;